import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { Form } from '@calendly/form'
import _PageContainer from "styles-PageContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=PageContainer";
import _ContentWrapper from "styles-ContentWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=ContentWrapper";
import _LeftColumn from "styles-LeftColumn.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=LeftColumn";
import _HeaderImageContainer from "styles-HeaderImageContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=HeaderImageContainer";
import _HeaderImage from "styles-HeaderImage.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=HeaderImage";
import _ProfileSection from "styles-ProfileSection.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=ProfileSection";
import _Avatar from "styles-Avatar.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=Avatar";
import _AvatarImage from "styles-AvatarImage.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=AvatarImage";
import _HostName from "styles-HostName.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=HostName";
import _PackageTitle from "styles-PackageTitle.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=PackageTitle";
import _InfoRowContainer from "styles-InfoRowContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=InfoRowContainer";
import _InfoRow from "styles-InfoRow.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=InfoRow";
import _IconWrapper from "styles-IconWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=IconWrapper";
import _SessionCount from "styles-SessionCount.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=SessionCount";
import _PackagePrice from "styles-PackagePrice.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=PackagePrice";
import _DescriptionBox from "styles-DescriptionBox.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=DescriptionBox";
import _Footer from "styles-Footer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=Footer";
import _LogoWrapper from "styles-LogoWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=LogoWrapper";
import _FooterLinks from "styles-FooterLinks.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=FooterLinks";
import _FooterLink from "styles-FooterLink.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=FooterLink";
import _RightColumn from "styles-RightColumn.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=RightColumn";
import _FormWrapper from "styles-FormWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=FormWrapper";
import _StyledForm from "styles-StyledForm.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=StyledForm";
import _PaymentSection from "styles-PaymentSection.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=PaymentSection";
import _PaymentSectionTitle from "styles-PaymentSectionTitle.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=PaymentSectionTitle";
import _TotalDueSection from "styles-TotalDueSection.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=TotalDueSection";
import _TotalDueLabel from "styles-TotalDueLabel.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=TotalDueLabel";
import _TotalDueAmount from "styles-TotalDueAmount.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=TotalDueAmount";
import _FormFieldsWrapper from "styles-FormFieldsWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=FormFieldsWrapper";
import _BottomSection from "styles-BottomSection.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=BottomSection";
import _PaymentTermsText from "styles-PaymentTermsText.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=PaymentTermsText";
import _ErrorMessage from "styles-ErrorMessage.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/styles.js?styleId=ErrorMessage";

const colorBackgroundStandard = 'var(--colorBackgroundStandard, var(--coreColorNeutral0))'
const colorBackgroundSecondary = 'var(--colorBackgroundSecondary, var(--coreColorNeutral100))'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
const colorTextStandard = 'var(--colorTextStandard, var(--coreColorNeutral900))'
const colorTextSecondary = 'var(--colorTextSecondary, var(--coreColorNeutral600))'
const colorTextDestructive = 'var(--colorTextDestructive, var(--coreColorRed700))'

export const PageContainer = /*#__PURE__*/styled('div', null, {
  displayName: "PageContainer",
  styles: _PageContainer,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const ContentWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "ContentWrapper",
  styles: _ContentWrapper,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const LeftColumn = /*#__PURE__*/styled('div', null, {
  displayName: "LeftColumn",
  styles: _LeftColumn,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const HeaderImageContainer = /*#__PURE__*/styled('div', null, {
  displayName: "HeaderImageContainer",
  styles: _HeaderImageContainer
})

export const HeaderImage = /*#__PURE__*/styled('img', null, {
  displayName: "HeaderImage",
  styles: _HeaderImage,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown'),
    isPhone: useDeviceType('isPhone')
  })
})

export const ProfileSection = /*#__PURE__*/styled('div', null, {
  displayName: "ProfileSection",
  styles: _ProfileSection,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const Avatar = /*#__PURE__*/styled('div', null, {
  displayName: "Avatar",
  styles: _Avatar,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const AvatarImage = /*#__PURE__*/styled('img', null, {
  displayName: "AvatarImage",
  styles: _AvatarImage
})

export const HostName = /*#__PURE__*/styled('div', null, {
  displayName: "HostName",
  styles: _HostName
})

export const PackageTitle = /*#__PURE__*/styled("h1", null, {
  displayName: "PackageTitle",
  styles: _PackageTitle
})

export const InfoRowContainer = /*#__PURE__*/styled('div', null, {
  displayName: "InfoRowContainer",
  styles: _InfoRowContainer,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const InfoRow = /*#__PURE__*/styled('div', null, {
  displayName: "InfoRow",
  styles: _InfoRow
})

export const IconWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "IconWrapper",
  styles: _IconWrapper
})

export const SessionCount = /*#__PURE__*/styled('span', null, {
  displayName: "SessionCount",
  styles: _SessionCount
})

export const PackagePrice = /*#__PURE__*/styled('span', null, {
  displayName: "PackagePrice",
  styles: _PackagePrice
})

export const DescriptionBox = /*#__PURE__*/styled('div', null, {
  displayName: "DescriptionBox",
  styles: _DescriptionBox
})


export const Footer = /*#__PURE__*/styled('div', null, {
  displayName: "Footer",
  styles: _Footer
})

export const LogoWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "LogoWrapper",
  styles: _LogoWrapper
})

export const FooterLinks = /*#__PURE__*/styled('div', null, {
  displayName: "FooterLinks",
  styles: _FooterLinks
})

export const FooterLink = /*#__PURE__*/styled('button', null, {
  displayName: "FooterLink",
  styles: _FooterLink
})

export const RightColumn = /*#__PURE__*/styled('div', null, {
  displayName: "RightColumn",
  styles: _RightColumn,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const FormWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "FormWrapper",
  styles: _FormWrapper,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const StyledForm = /*#__PURE__*/styled(Form, null, {
  displayName: "StyledForm",
  styles: _StyledForm
})

export const PaymentSection = /*#__PURE__*/styled("div", null, {
  displayName: "PaymentSection",
  styles: _PaymentSection
})

export const PaymentSectionTitle = /*#__PURE__*/styled('div', null, {
  displayName: "PaymentSectionTitle",
  styles: _PaymentSectionTitle
})

export const TotalDueSection = /*#__PURE__*/styled('div', null, {
  displayName: "TotalDueSection",
  styles: _TotalDueSection
})

export const TotalDueLabel = /*#__PURE__*/styled('div', null, {
  displayName: "TotalDueLabel",
  styles: _TotalDueLabel
})

export const TotalDueAmount = /*#__PURE__*/styled('div', null, {
  displayName: "TotalDueAmount",
  styles: _TotalDueAmount
})

export const FormFieldsWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "FormFieldsWrapper",
  styles: _FormFieldsWrapper
})

export const BottomSection = /*#__PURE__*/styled('div', null, {
  displayName: "BottomSection",
  styles: _BottomSection
})

export const PaymentTermsText = /*#__PURE__*/styled('div', null, {
  displayName: "PaymentTermsText",
  styles: _PaymentTermsText
})

export const ErrorMessage = /*#__PURE__*/styled("div", null, {
  displayName: "ErrorMessage",
  styles: _ErrorMessage
})
